import React from "react";
import PropTypes from "prop-types";
import { classStringBuilder } from "../support/helpers";
import { motion } from "framer-motion";

const propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  animationState: PropTypes.string,
};

const defaultProps = {
  className: "",
  animationState: "ENTERING",
};

const FadeWrapper = ({ children, className, animationState }) => {
  const defaultClasses = [];
  const additionalClasses = className.split(" ");
  const classes = classStringBuilder(defaultClasses, additionalClasses);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: animationState === "LEAVING" ? 0 : 1 }}
      transition={{ duration: 0.2 }}
      className={classes}
    >
      {children}
    </motion.div>
  );
};

FadeWrapper.propTypes = propTypes;

FadeWrapper.defaultProps = defaultProps;

export default FadeWrapper;
